module.exports = __webpack_public_path__ + "assets/iconfont.2bf80c88.ttf";